// extracted by mini-css-extract-plugin
export var heroImage = "_l2-1";
export var modal = "_l2-0";